import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelectAccess } from "../../store/stateFunctions";
import useQuickLook from "../../quicklook/useQuickLook";
import { server } from "../../common";
const initialValues = {
  shop_name: "",
  owner: "",
  mobile: "",
  email: "",
  details: "",
  address: "",
  landmark: "",
  city: "",
  pincode: "",
  location: "",
  url1: "",
  image: null,
  category: "",
  timing: "",
};

const swalalert = withReactContent(Swal);

const AddInternalMerchants = ({ role }) => {
  const user = useSelectAccess("Internal User");
  const displayFile = useQuickLook();
  const fileInputRef = useRef();

  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [excel, setExcel] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setIsEditMode(false);
    setSelectedData(null);
    formik.setValues(initialValues);
    setShow(true);
  };

  const handleCloseExcel = () => setExcel(false);
  const handleShowExcel = () => {
    setExcel(true);
  };

  const handleShowGallery = (data) => {
    setSelectedData(data);
    setIsEditMode(true);
    setShow(true);
  };

  useEffect(() => {
    getData();
    // Check if in edit mode and selectedData is available
    if (isEditMode && selectedData) {
      formik.setValues({
        shop_name: selectedData.shop_name,
        owner: selectedData.owner,
        mobile: selectedData.mobile,
        email: selectedData.email,
        details: selectedData.details,
        address: selectedData.address,
        city: selectedData.city,
        landmark: selectedData.landmark,
        pincode: selectedData.pincode,
        location: selectedData.location,
        url1: selectedData.url1,
        category: selectedData.category,
        timing: selectedData.timing,
      });
    }
  }, [isEditMode, selectedData]);

  // Get
  const getData = () => {
    server
      .get("/excel/getallmerchant_details", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete gallery
  const handleDelete = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/excel/deletemerchant_details/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Business has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // update news
  const handleUpdate = (values) => {
    const formData = new FormData();
    formData.append("shop_name", values.shop_name);
    formData.append("owner", values.owner);
    formData.append("mobile", values.mobile);
    formData.append("email", values.email);
    formData.append("details", values.details);
    formData.append("address", values.address);
    formData.append("landmark", values.landmark);
    formData.append("city", values.city);
    formData.append("pincode", values.pincode);
    formData.append("location", values.location);
    formData.append("url1", values.url1);
    formData.append("category", values.category);
    formData.append("timing", values.timing);

    if (values.image) {
      formData.append("image", values.image);
    }

    server
      .put(`/excel/updatemerchant_details/${values.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        formik.resetForm();
        getData();
        toast.success("Details Updated successfully");
        handleClose();
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // add
  const formik = useFormik({
    initialValues: isEditMode ? selectedData : initialValues,
    validationSchema: Yup.object({
      shop_name: Yup.string().required("Enter a Shop/Business Name"),
      owner: Yup.string().required("Enter a Owner Name"),
      mobile: Yup.string().required("Enter a Mobile Number"),
      email: Yup.string().required("Enter a Email Id"),
      details: Yup.string().required("Enter a Business Details"),
      address: Yup.string().required("Enter a Business Address"),
      landmark: Yup.string().required("Enter a landmark"),
      city: Yup.string().required("Enter a City"),
      pincode: Yup.string().required("Enter a Pincode"),
      location: Yup.string().required("Enter a Google Location Link"),
      url1: Yup.string().required("Enter a Website Link"),
      category: Yup.string().required("Enter a Business Category"),
      timing: Yup.string().required("Enter a Business Timing"),
      image: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          // Check the file size (if required)
          // Modify the limit according to your requirements
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      if (isEditMode) {
        handleUpdate({ ...values, id: selectedData.id });
      } else {
        if (!values.image) {
          toast.error("Please select a images");
          return;
        }
        const formData = new FormData();
        formData.append("shop_name", values.shop_name);
        formData.append("owner", values.owner);
        formData.append("mobile", values.mobile);
        formData.append("email", values.email);
        formData.append("details", values.details);
        formData.append("address", values.address);
        formData.append("landmark", values.landmark);
        formData.append("city", values.city);
        formData.append("pincode", values.pincode);
        formData.append("location", values.location);
        formData.append("url1", values.url1);
        formData.append("category", values.category);
        formData.append("timing", values.timing);
        formData.append("image", values.image);

        server
          .post("/adminmerchant/addmerchantdetails", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: user.authToken,
            },
          })
          .then(function (response) {
            if (response.status === 200 || response.status === 201) {
              toast.success("Business Added successfully");
              formik.resetForm();
              handleClose();
              getData();
            }
          })
          .catch(function (error) {
            if (error.response?.data?.message)
              toast.error(error.response.data.message);
            else if (error.response?.data?.error) {
              toast.error(error.response.data.error);
            } else toast.error("Failed to connect to server");
          });
      }
    },
  });

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/excel/searchmerchantdetails?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/adminmerchant/admfilter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const AddExcel = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("excelFile", fileInputRef.current.files[0]);
    server
      .post("/excel/addexcelshopdetails/excel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          toast.success(" Added successfully");
          formik.resetForm();
          handleCloseExcel();
        }
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
  };

  return (
    <>
      <div className="container">
        <div className="row my-3">
          <div className="col-md-4">
            <input
              type="search"
              className="form-control"
              placeholder="Search"
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <select
              className="form-control"
              name=""
              id=""
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option value="2days" defaultValue>
                Last 2 days
              </option>
              <option value="month" defaultValue>
                This Month
              </option>
              <option value="3months">Last 3 Months</option>
              <option value="6months">Last 6 Months</option>
            </select>
          </div>
        </div>
        <div className="d-flex position-relative mb-3 justify-content-center ">
          <h5 className="m-auto text-center">Previous Merchant Business</h5>
          <Button variant="contained" color="info" onClick={handleShow}>
            Add Merchant Business
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={handleShowExcel}
            className="ms-2"
          >
            Add Excel
          </Button>

          <Modal show={show} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditMode
                  ? "Edit Merchant Business"
                  : "Add Merchant Business"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                className="needs-validation d-flex flex-column gap-2"
                onSubmit={formik.handleSubmit}
              >
                <div className="">
                  <h5 className="mb-3">Business Details</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <TextField
                        name="shop_name"
                        margin="dense"
                        type="text"
                        value={formik.values.shop_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Shop Name"
                        variant="outlined"
                        label="Business Name"
                        fullWidth
                        required
                      ></TextField>
                      <p className="text-danger">{formik.errors.shop_name}</p>
                    </div>

                    <div className="col-md-6 ">
                      <TextField
                        name="owner"
                        margin="dense"
                        type="text"
                        value={formik.values.owner}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Owner's Full Name"
                        variant="outlined"
                        label="Owner"
                        fullWidth
                        required
                      ></TextField>
                      <p className="text-danger">{formik.errors.owner}</p>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-md-6">
                      <TextField
                        name="mobile"
                        margin="dense"
                        type="number"
                        value={formik.values.mobile}
                        onChange={formik.handleChange}
                        // disabled={!!props.edit}
                        onBlur={formik.handleBlur}
                        placeholder="Mobile Number"
                        variant="outlined"
                        label="Business Mobile Number"
                        fullWidth
                        required
                      ></TextField>
                      <p className="text-danger">{formik.errors.mobile}</p>
                    </div>

                    <div className="col-md-6">
                      <TextField
                        name="email"
                        margin="dense"
                        type="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Business Email"
                        variant="outlined"
                        label="Business Email"
                        fullWidth
                        required
                      ></TextField>
                      <p className="text-danger">{formik.errors.email}</p>
                    </div>
                  </div>
                  <div className="">
                    <TextField
                      name="details"
                      margin="dense"
                      type="text"
                      value={formik.values.details}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Describe your business (min 200 chars)"
                      variant="outlined"
                      label="Business Details"
                      fullWidth
                      multiline
                      minRows={3}
                      required
                    ></TextField>
                    <p className="text-danger">{formik.errors.details}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 d-flex gap-3 align-items-center mb-2">
                    <label htmlFor="image data-name">
                      Organization/Institute Photos
                    </label>
                    <input
                      name="image"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue(
                          "image",
                          event.target.files && event.target.files[0]
                        );
                      }}
                      // accept=".jpg,.png,.jpeg"
                    />
                    <p className="text-danger">{formik.errors.image}</p>
                  </div>
                </div>
                <div>
                  <h5 className="mb-3">Address Details</h5>
                  <div>
                    <div className="row ">
                      <div className="col-md-6">
                        <TextField
                          name="address"
                          type="text"
                          margin="dense"
                          value={formik.values.address}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="Address"
                          variant="outlined"
                          label="Address"
                          fullWidth
                          required
                        ></TextField>
                        <p className="text-danger">{formik.errors.address}</p>
                      </div>
                      <div className="col-md-6">
                        <TextField
                          name="landmark"
                          type="text"
                          margin="dense"
                          value={formik.values.landmark}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="Near Natraj Society"
                          variant="outlined"
                          label="Landmark"
                          fullWidth
                          required
                        ></TextField>
                        <p className="text-danger">{formik.errors.landmark}</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <TextField
                          name="city"
                          type="text"
                          margin="dense"
                          value={formik.values.city}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="City"
                          variant="outlined"
                          label="City"
                          fullWidth
                          required
                        ></TextField>
                        <p className="text-danger">{formik.errors.city}</p>
                      </div>
                      <div className="col-md-6">
                        <TextField
                          name="pincode"
                          type="number"
                          margin="dense"
                          value={formik.values.pincode}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="412216"
                          variant="outlined"
                          label="pincode"
                          fullWidth
                          required
                        ></TextField>
                        <p className="text-danger">{formik.errors.pincode}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div>
                          <TextField
                            name="location"
                            type="text"
                            margin="dense"
                            value={formik.values.location}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Geo Location"
                            variant="outlined"
                            label="Business Geo Location Link"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">
                            {formik.errors.location}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div>
                          <TextField
                            name="url1"
                            type="text"
                            margin="dense"
                            value={formik.values.url1}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Website Url"
                            variant="outlined"
                            label="Website Url"
                            fullWidth
                            required
                          ></TextField>
                          <p className="text-danger">{formik.errors.url1}</p>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <FormControl fullWidth required className="mb-2">
                          <InputLabel id="demo-simple-select-label">
                            Year
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="category"
                            variant="outlined"
                            name="category"
                            value={formik.values.category}
                            onChange={formik.handleChange}
                            required
                          >
                            <MenuItem value="gym">Gym</MenuItem>
                            <MenuItem value="cafe">Cafe</MenuItem>
                            <MenuItem value="lodge">Lodge</MenuItem>
                            <MenuItem value="bakery">Bakery</MenuItem>

                            <MenuItem value="classes">Classes</MenuItem>
                            <MenuItem value="library">Library</MenuItem>
                            <MenuItem value="travel">Travels</MenuItem>
                            <MenuItem value="loundry">Loundry</MenuItem>
                            <MenuItem value="garage">Garage</MenuItem>
                            <MenuItem value="medical">Medical</MenuItem>
                            <MenuItem value="restaurants">Restaurants</MenuItem>
                            <MenuItem value="stationary">Stationary</MenuItem>
                            <MenuItem value="cyber_cafe">Cyber Cafe</MenuItem>
                            <MenuItem value="event_decors">
                              Event Decors
                            </MenuItem>
                            <MenuItem value="pg/hostels">PG/Hostels</MenuItem>

                            <MenuItem value="doctor/clinic">
                              Doctor/Clinics
                            </MenuItem>
                            <MenuItem value="mess/parcel">
                              Mess/Parcel Point
                            </MenuItem>
                            <MenuItem value="salon/parlor">
                              Saloon/Parlor
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      <div className="col-md-6 mb-3">
                        <TextField
                          name="timing"
                          type="text"
                          value={formik.values.timing}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="412216"
                          variant="outlined"
                          label="Business Timing"
                          fullWidth
                          required
                        ></TextField>
                        <p className="text-danger">{formik.errors.pincode}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  <span className="mb-1 d-block">
                    <input type="checkbox" name="" id="" /> &nbsp; All The Above
                    Information is Correct and If It Is Wrong Then I Am
                    Responsible For The Same.
                  </span>
                  <Button
                    className="banner text-white p-1 rounded-2 border-0 w-50"
                    type="submit"
                  >
                    Save
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          <Modal show={excel} onHide={handleCloseExcel}>
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditMode
                  ? "Edit Merchant Business"
                  : "Add Merchant Business"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form
                className="needs-validation d-flex flex-column gap-2"
                onSubmit={(e) => AddExcel(e, user)}
              >
                <div className="col-md-6 ">
                  <label htmlFor="image data-name">Merchant Excel File</label>
                  <input
                    name="excelFile"
                    type="file"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                  />
                  <p className="text-danger">{formik.errors.image}</p>
                </div>
                <div className="text-center">
                  {/* <span className="mb-1 d-block">
                    <input type="checkbox" name="" id="" /> &nbsp; All The Above
                    Information is Correct and If It Is Wrong Then I Am
                    Responsible For The Same.
                  </span> */}
                  <Button
                    className="banner text-white p-1 rounded-2 border-0 w-50"
                    type="submit"
                  >
                    Save
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </div>

        <div className="container" style={{ overflowX: "scroll" }}>
          <table class="table table-striped border">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Merchant Id</th>
                <th>Business Name</th>
                <th>Owner</th>
                <th>Contact No.</th>
                <th> Email</th>
                <th>Details</th>
                <th>Category</th>
                <th>Timing</th>
                <th>Address</th>
                <th>Landmark</th>
                <th>City</th>
                <th>Pincode</th>
                <th>Location</th>
                <th>Website URL</th>
                <th>Images</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th>{index + 1}</th>
                    <th>{item.id}</th>
                    <td>{item.shop_name}</td>
                    <td>{item.owner}</td>
                    <td>{item.mobile}</td>
                    <td>{item.email}</td>
                    <td>{item.details}</td>
                    <td>{item.category}</td>
                    <td>{item.timing}</td>
                    <td>{item.address}</td>
                    <td>{item.landmark}</td>
                    <td>{item.city}</td>
                    <td>{item.pincode}</td>
                    <td>
                      <a href={item.location}>View Location</a>
                    </td>
                    <td>{item.url1}</td>
                    <td>
                      <a href={item.image} target="_blank">
                        <img
                          width="50"
                          height="50"
                          src={item.image}
                          // alt={item.file}
                        />
                      </a>
                    </td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillEdit onClick={() => handleShowGallery(item)} />
                      </div>
                    </td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillDelete onClick={() => handleDelete(item)} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AddInternalMerchants;
